export const EVENTS = {
  Call: 'Call',
  Email: 'Email',
  AppDownload: 'AppDownload',
  ButtonClicked: 'ButtonClicked',
  ChipClicked: 'ChipClicked',
  SocialMediaButtonClicked: 'SocialMediaButtonClicked',
  LinkClicked: 'LinkClicked',
  ProductListClicked: 'ProductListClicked',
  NavigationItemClicked: 'NavigationItemClicked',
  LanguageSwitch: 'LanguageSwitch',
  RegionSwitch: 'RegionSwitch',
  AccordionItemToggled: 'AccordionItemToggled',
  TableAccordionItemToggled: 'TableAccordionItemToggled',
  ProductViewed: 'Product Viewed',
  $experiment_started: '$experiment_started',
  RadioCardSetClicked: 'RadioCardSetClicked',
  Streamable: 'Streamable',
  CarouselSwiped: 'CarouselSwiped',
  ModalShown: 'ModalShown',
  ModalClosed: 'ModalClosed',
} as const

export const BUTTONS_IDS = {
  // hero sections ctas
  HEADER_CTA: 'HEADER_CTA',
  PRESS_PAGE_YEAR: 'PRESS_PAGE_YEAR',
  PRESS_RELEASE_PDF: 'PRESS_RELEASE_PDF',
  PRESS_RELEASE_LINK: 'PRESS_RELEASE_LINK',
  LOAD_MORE_PRESS_RELEASES: 'LOAD_MORE_PRESS_RELEASES',
  LOAD_LESS_PRESS_RELEASES: 'LOAD_LESS_PRESS_RELEASES',
  BUTTON_FROM_SANITY_CONTENT: 'BUTTON_FROM_SANITY_CONTENT',
  StickyFooterGetQuoteButton: 'StickyFooterGetQuoteButton',
  WHATSAPP_BUTTON: 'WHATSAPP_BUTTON',
  STORIES_BUTTON_PREVIOUS: 'STORIES_BUTTON_PREVIOUS',
  STORIES_BUTTON_NEXT: 'STORIES_BUTTON_NEXT',
  PROMOTION_MODAL_BUTTON: 'PROMOTION_MODAL_BUTTON',
} as const

export const LINKS_IDS = {
  // sticky header links
  HEADER_NAVIGATION_LOGO_TO_INDEX: 'HEADER_NAVIGATION_LOGO_TO_INDEX',
  HEADER_NAVIGATION_LOGIN: 'HEADER_NAVIGATION_LOGIN',

  // footer links
  FOOTER_COOKIE_SETTINGS: 'FOOTER_COOKIE_SETTINGS',
  SWITCH_TO_ENGLISH: 'SWITCH_TO_ENGLISH',
  STYLED_LINK: 'STYLED_LINK',
  TRAVEL_HEALTH_WAITING_LIST: 'TRAVEL_HEALTH_WAITING_LIST',
}
